export class Action {
  constructor(public type: string, public payload?: any) { }
};
